import Types from './types';
import { createReducer } from 'reduxsauce';

const INITIAL_STATE = {
    total: 0,
    shortlistedVehicles: [],
    config: null,
    isLoading: false,
};
const auctionRequest = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: true
    };
};
const auctionResponse = (state = INITIAL_STATE) => {
    return {
        ...state,
        isLoading: false
    };
};
const setWatchList = (state = INITIAL_STATE, { data }) => {
    return {
        ...state,
        ...data,
        isLoading: false
    };
};

const HANDLERS = {
    [Types.WATCH_LIST_REQUEST]: auctionRequest,
    [Types.WATCH_LIST_RESPONSE]: auctionResponse,
    [Types.SET_WATCH_LIST]: setWatchList
};

export default createReducer(INITIAL_STATE, HANDLERS);